import type { SpanT } from '../types';
export function extendSpan(spans: SpanT[], frameIndex: number): SpanT[] {
  if (spans.length === 0) {
    return [{
      start: frameIndex,
      end: frameIndex
    }];
  }
  const last = spans[spans.length - 1];
  if (!last) {
    return [...spans, {
      start: frameIndex,
      end: frameIndex
    }];
  }
  if (frameIndex === last.end + 1) {
    return [...spans.slice(0, -1), {
      ...last,
      end: frameIndex
    }];
  }
  if (frameIndex > last.end + 1) {
    return [...spans, {
      start: frameIndex,
      end: frameIndex
    }];
  }

  // frameIndex <= last.end: already covered
  return spans;
}